<template>
  <b-card>
    <b-row>
      <b-col>
        <b-tabs>
          <b-tab :title="$t('views.excmcase.list.searchParams.filterCaseByCustomField')">
            <caseCustomFields></caseCustomFields>
          </b-tab>
          <b-tab :title="$t('views.excmcase.list.searchParams.filterTaskByCustomField')">
            <taskCustomFields></taskCustomFields>
          </b-tab>
        </b-tabs>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import { checkPagePermission } from '@/utils/checkRoles'
import caseCustomFields from '@/components/Dashboard/Views/reports/components/caseCustomFields.vue'
import taskCustomFields from '@/components/Dashboard/Views/reports/components/taskCustomFields.vue'

export default {
  name: 'excmCustomFields',
  components: { caseCustomFields, taskCustomFields },
  beforeCreate () {
    checkPagePermission('configuration', 'EXCMCustomFieldsReportList')
  }
}
</script>
